<template>
  <div>
    <CandidateInviteAuto v-model="autoInvitation" class="mb-2" />
    <CandidateInviteMethods
      v-model="noticeMethod"
    />
    <slot name="actions">
      <VBtn
        v-if="!localLoading || backgroundLoading"
        @click="save"
        width="9.125rem"
        color="#1FC57F"
        depressed
        class="int-btn d-flex mt-2 mx-auto"
      >
        <slot name="btn">
          {{ $t('apply') }}
        </slot>
      </VBtn>
      <Preloader v-else />
    </slot>
  </div>
</template>

<script>
import { candidateNotificationTypes, candidatesInviteTypes } from '@/enums';
import useValidation from '@/compositions/useValidation';
import { computed, ref, toRefs } from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import Preloader from '@/components/Preloader';
import CandidateInviteMethods from '@/components/Candidate/CandidateInviteMethods';
import useVacancies from '@/compositions/useVacancies';
import CandidateInviteAuto from '@/components/Candidate/CandidateInviteAuto';

export default {
  name: 'IntegrationsInviteMethod',
  components: { CandidateInviteAuto, CandidateInviteMethods, Preloader },
  props: {
    wizard: Boolean,
    vacancy: {
      type: Object,
      default: null,
    },
    backgroundLoading: Boolean,
  },
  setup(props, { emit, root }) {
    const { t } = useI18n();
    const { vacancy } = toRefs(props);
    const { hasErrors, withValidationHandling, localLoading } = useValidation();
    const { updateSettings } = useVacancies();

    const entityId = vacancy.value?.id;
    const autoInvitation = ref(vacancy.value?.settings?.autoInvitation);

    const noticeMethod = ref(
      vacancy.value?.settings?.notificationMethod
      || candidateNotificationTypes.EMAIL,
    );

    const settingsStore = computed(() => {
      return {
        notificationMethod: noticeMethod.value,
        autoInvitation: autoInvitation.value,
      };
    });

    async function save() {
      await withValidationHandling(async () => {
        await updateSettings(entityId, settingsStore.value);
      });
      if (!hasErrors.value) {
        emit('saved');
      } else {
        // TODO: сделать вывод ошибок(?)
      }
    }

    return {
      save,
      noticeMethod,
      candidatesInviteTypes,
      candidateNotificationTypes,
      localLoading,
      settingsStore,
      autoInvitation,
    };
  },
};
</script>

<i18n locale="en" lang="yml">

</i18n>
<i18n locale="ru" lang="yml">
  invite: Приглашение кандидатов
  description: Huntica автоматически импортирует отклики кандидатов с Работа.ру.
  description2: 'Выберите поведение по умолчанию, которое будет использоваться для новых импортированных вакансий.
  Чтобы кандидаты смогли записать видеоотклик, им необходимо отправить приглашение.'
  inviteType: Автоприглашение
  self: Я сам выберу, кого приглашать
  selfDescription: 'Вы сами решаете, кому отправить приглашение, а кому – нет. Рекомендуется при подборе квалифицированных специалистов.'
  all: 'Приглашать кандидатов автоматически (рекомендуется)'
  allDescription: 'Кандидат получит приглашение в течение часа после того, как откликнется на вакансию на Работа.ру.
  Рекомендуется для вакансий, на которые приходит очень много откликов (массовый набор, массовые профессии).'
  howToNotice: Как оповещать кандидатов
  call: Звонок роботом
  apply: Применить
  dataSaved: Данные сохранены
</i18n>
